import { Injectable } from '@angular/core';
import jsPDF from 'jspdf';

@Injectable({
  providedIn: 'root'
})
export class PdfJsService extends jsPDF {
  constructor() {
    super();
  }
}
